import { useState, useEffect, useCallback, useRef } from 'react';

const useInfiniteScroll = (callback) => {
  const [isFetching, setIsFetching] = useState(false);
  const observerRef = useRef(null);
  const loadMoreRef = useRef(null);

  const handleObserver = useCallback((entries) => {
    const [target] = entries;
    if (target.isIntersecting && !isFetching) {
      setIsFetching(true);
    }
  }, [isFetching]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '20px',
      threshold: 0.1
    };

    observerRef.current = new IntersectionObserver(handleObserver, option);
    const currentTarget = loadMoreRef.current;
    
    if (currentTarget) {
      observerRef.current.observe(currentTarget);
    }

    return () => {
      if (currentTarget) {
        observerRef.current.unobserve(currentTarget);
      }
    };
  }, [handleObserver]);

  useEffect(() => {
    if (!isFetching) return;
    callback();
  }, [isFetching, callback]);

  return { isFetching, setIsFetching, loadMoreRef };
};

export default useInfiniteScroll;